import React, { useState } from "react";
// import QuillEditor from "../postEditor/quillEditor";
import { getProfile } from "../../../services/authservice";
import { savePost } from "../../../services/posts";
import { saveTopic } from "../../../services/topics";
// import ReactHtmlParser from "react-html-parser";
import moment from "moment";
// import MultipleFileDropzone from "../../../components/PageForum/form/fileUploader";
// import { saveAttachmentsInternalTopic } from "../../../services/attachments";
import MyEditor from "../../../components/common/Editor";

const PostReplyForm = ({ submitForm, Post, quote, message, loadPage }) => {
  const [myPost, setMyPost] = useState({ reply: "", quote });
  const [attachments, setAttachments] = useState([]);
  const [files, setFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const updatePost = (content) => {
    console.log(content);
    setMyPost({ reply: content });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    submitForm(e);

    const generateQuoteForSave = `${message}\n\n${myPost.reply}`;

    const postData = {
      ...Post,
      narrative: generateQuoteForSave,
    };

    const currentUser = await getProfile();

    let editPostData = {};
    if (quote === "topic") {
      editPostData = {
        topicId: Post._id,
        narrative: generateQuoteForSave,
        user: currentUser._id,
        status: "active",
      };

      try {
        const resp = await savePost(editPostData);
        if (attachments?.length > 0) {
          // Use a state to track the progress
          // Call saveAttachmentsInternalTopic with the onUploadProgress callback
          console.log(attachments);
          // const data = await saveAttachmentsInternalTopic(
          //   attachments,
          //   "post",
          //   resp?.data?._id,
          //   (progressEvent) => {
          //     const progress = Math.round(
          //       (progressEvent.loaded / progressEvent.total) * 100
          //     );
          //     setUploadProgress(progress);
          //     console.log("this is progress");
          //     console.log(progress);
          //   }
          // );
          // console.log(data);
        }
      } catch (error) { }
    } else {
      editPostData = {
        topicId: Post.topicId._id,
        parentId: Post._id,
        narrative: generateQuoteForSave,
        user: currentUser._id,
        status: "active",
      };

      try {
        const resp = await savePost(editPostData);
        if (attachments?.length > 0) {
          // Use a state to track the progress
          // Call saveAttachmentsInternalTopic with the onUploadProgress callback
          console.log(attachments);
          // const data = await saveAttachmentsInternalTopic(
          //   attachments,
          //   "post",
          //   resp?.data?._id,
          //   (progressEvent) => {
          //     const progress = Math.round(
          //       (progressEvent.loaded / progressEvent.total) * 100
          //     );
          //     setUploadProgress(progress);
          //     console.log("this is progress");
          //     console.log(progress);
          //   }
          // );
          // console.log(data);
        }
      } catch (error) { }
    }

    loadPage();
  };

  // Function to strip HTML tags from a string
  const stripHtmlTags = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.innerText || div.textContent;
  };

  const originalMessage = `${Post.user?.contactName.first} ${Post.user?.contactName.last} wrote:`;

  return (
    <div style={{ marginTop: "20px" }}>
      <form className="mt-2">
        <div className="d-flex flex-column mt-n2">
          <p style={{ marginBottom: "10px" }}>{originalMessage}</p>
          <div className="mb-2">
            <MyEditor
              initialContent={message}
              readOnly={true}
            />
          </div>
          {/* <QuillEditor onEditorChange={updatePost} value={myPost.reply} /> */}
          <MyEditor
            initialContent={myPost.reply}
            onChangeHandler={(text) => updatePost(text)}
          />
        </div>
        {/* <MultipleFileDropzone
          setAttachments={setAttachments}
          files={files}
          setFiles={setFiles}
        /> */}
        <br />
        <div className="mt-n2">
          <button
            className="btn btn-outline-secondary btn-sm mr-1"
            type="submit"
            onClick={handleSubmit}
          >
            Submit
          </button>
          <button
            className="btn btn-outline-secondary btn-sm"
            type="submit"
            onClick={submitForm}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default PostReplyForm;
